// Session + identity state. The tech name is self-reported and device-local (v1
// contract): techs set it once; only admins change it afterwards.
import { computed, signal } from '@preact/signals';
import { apiGet, apiPost, authRequired } from '../lib/api';
import { vapidPublic } from '../lib/push';

export const role = signal<'admin' | 'tech'>('tech');
export const techName = signal<string>(localStorage.getItem('techName') || '');
export const needsName = computed(() => !techName.value);

export function setTechName(name: string): void {
  const clean = name.trim().slice(0, 60);
  if (!clean) return;
  techName.value = clean;
  localStorage.setItem('techName', clean);
}

export async function login(code: string): Promise<{ ok: boolean; error?: string }> {
  try {
    const res = await apiPost<{ ok: boolean; role: 'admin' | 'tech' }>('/api/login', { code });
    role.value = res.role;
    authRequired.value = false;
    return { ok: true };
  } catch (e) {
    const err = e as { status?: number; body?: { retryMinutes?: number } };
    if (err.status === 429) {
      return { ok: false, error: `Too many tries — wait ${err.body?.retryMinutes ?? 10} min` };
    }
    if (err.status === 503) return { ok: false, error: 'App not configured — call the office' };
    return { ok: false, error: 'Wrong code' };
  }
}

export async function fetchRole(): Promise<void> {
  try {
    const res = await apiGet<{ role: 'admin' | 'tech'; vapidPublic?: string }>('/api/whoami');
    role.value = res.role;
    vapidPublic.value = res.vapidPublic ?? '';
  } catch {
    // 401 already flipped the gate; other errors leave the default tech role
  }
}
